<template>
  <div>
    <!-- <h1 class="forget-title">忘记密码</h1> -->
    <p class="forget-text">我不修改密码了，<span class="color-blue" @click="$emit('ChangeForgetPwd', false)">去登录</span></p>
    <el-form hide-required-asterisk :model="forgetPwdMsg" :rules="forgetPwdRules" ref="forgetLoginFormRef" class="login_from">
      <el-form-item prop="phone" label="手机号" label-width="100%">
        <el-input placeholder="手机号" v-model="forgetPwdMsg.phone" clearable></el-input>
      </el-form-item>
      <el-form-item prop="code" label="验证码" label-width="100%" class="verification-code">
        <el-input style="width:404px" placeholder="验证码" v-model="forgetPwdMsg.code" type="text" autocomplete="off" clearable></el-input>
        <el-button @click="forgetGetCode" style="width:138px" :disabled='forgetBtn' :class="{ 'bg-text': forgetBtn }">{{ forgettext }}</el-button>
      </el-form-item>
      <el-form-item prop="password" label="密码" label-width="100%">
        <el-input clearable placeholder="密码由数字，大小写字母构成" type="text" class="password" :class="show ? '' : 'displayPass'" v-model="forgetPwdMsg.password" autocomplete="new-password">
        </el-input>
      </el-form-item>
      <div class="login_btn">
        <el-button @click="forgetPwdLogin">确认修改</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { codeSms, userFindPwd } from '@/api/crm'

export default {
  data () {
    return {
      show: false,
      forgetBtn: false,
      forgetTimer: '',
      forgettext: '获取验证码',
      // 忘记密码
      forgetPwdMsg: {
        code: '',
        password: '',
        phone: '',
        passwordAgain: ''
      },
      forgetPwdRules: {
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    forgetGetCode () {
      this.$refs.forgetLoginFormRef.validateField('phone', errorMessage => {
        if (errorMessage) return false
        codeSms(this.forgetPwdMsg.phone, 'FINDPWD').then(res => {
          if (res.data.success) {
            this.$message({
              message: '发送成功',
              type: 'success'
            })
            this.forgetBtn = true
            this.forgettext = '已发送 (' + 120 + 's)'
            let i = 119
            const forgetTimer = setInterval(() => {
              this.forgettext = '已发送 (' + i + 's)'
              i--
              if (i < 0) {
                this.forgetBtn = false
                this.forgettext = '获取验证码'
                clearInterval(forgetTimer)
              }
            }, 1000)
          } else {
            if (res.data.message === 'crm.phone.code.send.failed') {
              this.$message({
                message: '发送失败',
                type: 'error'
              })
            } else if (res.data.message === 'crm.phone.code.has.send') {
              this.$message({
                message: '已经发送验证码，请稍后',
                type: 'error'
              })
            }
          }
        })
      })
    },
    forgetPwdLogin () {
      this.$refs.forgetLoginFormRef.validate(vaild => {
        if (!vaild) {
          return false
        }
        userFindPwd(this.forgetPwdMsg).then(res => {
          if (res.data.success) {
            this.$message.success('修改密码成功，请登录')
            this.$emit('ChangeForgetPwd', false)
          }
        })
      })
    }
  }
}
</script>

<style lang="less">
@deep: ~">>>";

.displayPass {
  text-security: disc;
  -webkit-text-security: disc;
}
</style>
